// // Fixing the mini cart item display height
function setMiniCartItemDisplay() {
  const miniCartItemWrapper = document.querySelector('.mini-cart-item-wrapper');
  const discountDisplay = document.querySelector('.mini-cart-flyout .stack-discounts-applied-discount');
  if (discountDisplay && discountDisplay.getAttribute('data-discount-value') != 0) {
    if (miniCartItemWrapper) {
      miniCartItemWrapper.style.height = 'calc(100% - 350px)';
    }
  }
}
setTimeout(async () => {setMiniCartItemDisplay()}, 2000);

// Function to be executed when Nosto reels are added
let nostoReelsDetected = false; 
function handleNostoReels(mutationsList, observer) {
  mutationsList.forEach((mutation) => {
    if (mutation.type === 'childList') {
      const nostoReels = document.querySelectorAll('.nosto_element .product-recommendations'); // Adjust the selector as needed
      if (nostoReels.length > 0 && !nostoReelsDetected) {
        nostoReelsDetected = true;
        nostoReels.forEach((nostoReel) => {
          const addToCartButtons = nostoReel.querySelectorAll('.nosto-atc-container .nosto-atc');
          addToCartButtons.forEach((addToCartButton) => {
            addToCartButton.addEventListener('click', function () {
              updateMiniCartDisplay();
            });
          });
        });
      }
    }
  });
}
const targetNode = document.body;
const config = { childList: true, subtree: true };
const nostoObserver = new MutationObserver(handleNostoReels);
nostoObserver.observe(targetNode, config);

// Gets the minicart Update after product from nosto is added
function updateMiniCartDisplay() {
  setTimeout(async () => {
    const miniCart = await fetch("/cart?view=mini").then(results => results.text());
    var parser = new DOMParser();
    var parsedData = parser.parseFromString(miniCart, 'text/html');
    const emptyCart = document.querySelector('.mini-cart-item-empty-wrapper');

    // To update subtotal
    if (emptyCart) {
      const newMiniCartFooter = parsedData.querySelector('#main-cart-footer');
      const miniCartFooter = document.querySelector('#main-cart-footer');
      if (miniCartFooter) {
        miniCartFooter.innerHTML = newMiniCartFooter.innerHTML;
    
        if (miniCartFooter.classList.contains('is-empty')) {
          miniCartFooter.classList.remove('is-empty');
        }
      }
    }

    // To update heading
    const newMiniCartHeading = parsedData.querySelector('.mini-cart-heading');
    const miniCartHeading =  document.querySelector('.mini-cart-heading');
    const cartHeading =  document.querySelector('.cart-heading');
    if (miniCartHeading) {
      miniCartHeading.innerHTML = newMiniCartHeading.innerHTML;

      if (emptyCart && miniCartHeading.classList.contains('visibility-hidden')) {
        miniCartHeading.classList.remove('visibility-hidden');
      }
    } else if (cartHeading) {
      cartHeading.innerHTML = newMiniCartHeading.innerHTML;
    }

    // To update progress bar
    const newMiniProgressBar = parsedData.querySelector('.mini-cart-progress-bar');
    const miniProgressBar = document.querySelector('.mini-cart-progress-bar');
    const cartProgressBar = document.querySelector('.cart-progress-bar');
    if (miniProgressBar) {
      miniProgressBar.innerHTML = newMiniProgressBar.innerHTML;

      if (emptyCart && miniProgressBar.classList.contains('hidden')) {
        miniProgressBar.classList.remove('hidden');
      }
    } else if (cartProgressBar) {
      cartProgressBar.innerHTML = newMiniProgressBar.innerHTML;
    }

    // To update cart items
    const newMiniCartItem = parsedData.querySelector('cart-items');
    const miniCartItem = document.querySelector('cart-items');
    if (miniCartItem) {
      miniCartItem.innerHTML = newMiniCartItem.innerHTML;

      if (emptyCart && miniCartItem.classList.contains('is-empty')) {
        miniCartItem.classList.remove('is-empty');
        emptyCart.classList.remove('mini-cart-item-empty-wrapper');
        miniCartItem.getSectionsToRender().map((section) => section.id);
      }
    }

    // To update the cart counter
    const cartCounter = document.querySelector('.cart-count-bubble');
    if (!cartCounter) {
      const newitemCountElement =  parsedData.querySelector('.mini-cart-heading .mini-cart-title .mini-cart-count-display');
      const newitemCount = newitemCountElement.innerHTML.split('(')[1].split(')')[0];
      const itemCountElement = document.querySelector('.mini-cart-button span');
      const newitemDiv = document.createElement("div");
      newitemDiv.classList.add('cart-count-bubble');
      const newItemHiddenSpan = document.createElement("span");
      newItemHiddenSpan.classList.add('visually-hidden');
      newItemHiddenSpan.innerHTML = newitemCount + "item";
      const newItemSpan = document.createElement("span");
      newItemSpan.setAttribute('aria-hidden',true);
      if (Number(newitemCount) < 100) {
        newItemSpan.innerHTML =  newitemCount;
      } else {
        newItemSpan.innerHTML = "99+";
      }
      newitemDiv.append(newItemSpan);
      newitemDiv.append(newItemHiddenSpan);
      itemCountElement.after(newitemDiv);
    }
  }, 1000);
}

const miniCartFlyout = document.querySelector('.mini-cart-flyout');
const miniCartCover =  document.getElementById('miniCartCover');
const miniCartFlyoutButton = document.querySelector('.mini-cart-button');
const miniCartFlyoutClose = document.querySelector('.mini-cart-flyout__close');
const disableScroll = document.querySelector('html');
const miniCartFooterSection =  document.querySelector('.mini-cart-footer-section'); 
const miniCartItemSection = document.querySelector('.mini-cart-item-wrapper'); 

// To open mini cart on button click
function miniCartOpen() {
  if (miniCartFlyoutButton) {
    miniCartFlyoutButton.addEventListener('click', function () {
      miniCartFlyout.classList.add('mini-cart-flyout-on-screen');
      if (miniCartCover) {
        miniCartCover.classList.add('miniCartCoverFaded');
      }
      if (disableScroll) {
        disableScroll.classList.add('disableScroll');
      }
    });
  }
}
miniCartOpen();

// To close minicart on button click
function miniCartClose() {
  if (miniCartFlyoutClose) {
    miniCartFlyoutClose.addEventListener('click', function () {
      if(miniCartFlyout.classList.contains('mini-cart-flyout-on-screen')) {
        miniCartFlyout.classList.remove('mini-cart-flyout-on-screen');
        if(miniCartCover && miniCartCover.classList.contains('miniCartCoverFaded')) {
          miniCartCover.classList.remove('miniCartCoverFaded');
        }
        if (disableScroll && disableScroll.classList.contains('disableScroll')) {
          disableScroll.classList.remove('disableScroll');
        }
      }
    });
  }
  if (miniCartCover) {
    miniCartCover.addEventListener('click', function (event) {
      miniCartFlyoutClose.click();
    });
  }
}
miniCartClose();

function emptyMiniCartLayout() {
  if (miniCartFooterSection.classList.contains('is-empty')) {
    miniCartItemSection.classList.add('mini-cart-item-empty-wrapper');
  } else {
    if (miniCartItemSection.classList.contains('mini-cart-item-empty-wrapper')) {
      miniCartItemSection.classList.remove('mini-cart-item-empty-wrapper');
    }
  }
}
emptyMiniCartLayout();

class CartNote extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('change', debounce((event) => {
      const body = JSON.stringify({ note: event.target.value });
      fetch(`${routes.cart_update_url}`, {...fetchConfig(), ...{ body }});
    }, 300))
  }
}

customElements.define('cart-note', CartNote);

//Cart Refresh Glitch Fix 
const cartItemSelectors = document.querySelectorAll('.cart-item-load');
if(cartItemSelectors) {
  cartItemSelectors.forEach((cartItemSelector) => {
    if(cartItemSelector.classList.contains('hidden')) {
      cartItemSelector.classList.remove('hidden');
    }
  });
}

class CartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-items').updateQuantity(this.dataset.index, 0);
    });
  }
}

customElements.define('cart-remove-button', CartRemoveButton);

class CartItems extends HTMLElement {
  constructor() {
    super();

    this.lineItemStatusElement = document.getElementById('shopping-cart-line-item-status');

    this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
      .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

    this.debouncedOnChange = debounce((event) => {
      this.onChange(event);
    }, 300);

    this.addEventListener('change', this.debouncedOnChange.bind(this));
  }

  onChange(event) {
    const target = event.target;
    if (target.matches("[name^='selling-plan']")){
      const sellingPlanContainer = target.closest("[id^='Selling-plan-']");
      let sellingPlanValue = null;
      if (!target.matches("[name^='selling-plan-'][value='one-time']")) {
        sellingPlanValue = sellingPlanContainer.querySelector("[name='selling-plan-frequency']").value;
      }

      this.updateSellingPlan(sellingPlanContainer.dataset.index, sellingPlanValue, document.activeElement.getAttribute('name'));
      return;
    }

    this.updateQuantity(target.dataset.index, target.value, document.activeElement.getAttribute('name'));
  }

  getSectionsToRender() {
    StackDiscounts.reload = true;
    StackDiscounts.initStackDiscounts();
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.js-contents',
      },
      {
        
        id: 'cart-free-shipping',
        section: document.getElementById('main-cart-items').dataset.id,
        selector: '.flex-end'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      },
      {
        id: 'cart-live-region-text',
        section: 'cart-live-region-text',
        selector: '.shopify-section'
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer').dataset.id,
        selector: '.js-contents-footer',
      }
    ];
  }

  updateQuantity(line, quantity, name) {
    this.enableLoading(line);

    if(quantity > 10) {
      quantity = 10;
    } else if (quantity < 0) {
      quantity = 0;
    }
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    this.updateCart(body, name, line);
  }

  updateSellingPlan(line, selling_plan, name) {
    this.enableLoading(line);

    const quantity = document.getElementById(`Quantity-${line}`).value;

    const body = JSON.stringify({
      line,
      quantity,
      selling_plan,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });

    this.updateCart(body, name);
  }

  updateCart(body, name, line) {
    fetch(`${routes.cart_change_url}`, {...fetchConfig(), ...{ body }})
      .then((response) => {
        return response.json();
      })
      .then((state) => {
        this.classList.toggle('is-empty', state.item_count === 0);
        const cartFooter = document.getElementById('main-cart-footer');

        if (cartFooter) cartFooter.classList.toggle('is-empty', state.item_count === 0);

        this.getSectionsToRender().forEach((section => {
          const elementToReplace =
            document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

          elementToReplace.innerHTML =
            this.getSectionInnerHTML(state.sections[section.section], section.selector);
        }));

        this.updateLiveRegions(line, state.item_count);
        const lineItem =  document.getElementById(`CartItem-${line}`);
        if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
        this.disableLoading();

        THKAnalitycs['removeFromCart'].refresh();
        THKAnalitycs['addToCart'].refresh();
      }).catch((e) => {
        console.error(e);
        this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
        document.getElementById('cart-errors').textContent = `<div class="site-messages__message">${window.cartStrings.error}</div>`;
        this.disableLoading();
      });
  }

  updateLiveRegions(line, itemCount) {
    if (this.currentItemCount === itemCount) {
      const lineItemErrorEl = document.getElementById(`Line-item-error-${line}`);
      if (lineItemErrorEl) {
        lineItemErrorEl.querySelector('.cart-item__error-text')
          .innerHTML = window.cartStrings.quantityError.replace(
          '[quantity]',
          document.getElementById(`Quantity-${line}`).value
        );
      }
    }

    this.currentItemCount = itemCount;
    this.lineItemStatusElement.setAttribute('aria-hidden', true);

    const cartStatus = document.getElementById('cart-live-region-text');
    cartStatus.setAttribute('aria-hidden', false);

    setTimeout(() => {
      cartStatus.setAttribute('aria-hidden', true);
    }, 1000);

    // Display fix when cart is empty
    emptyMiniCartLayout();

    // Updating mini cart heading when items inside mini cart are modified
    const miniCartHeading = document.querySelector('.mini-cart-heading');
    if (miniCartHeading &&  itemCount == 0) {
      miniCartHeading.classList.add('visibility-hidden');
    } else {
      if (miniCartHeading.classList.contains('visibility-hidden')) {
        miniCartHeading.classList.remove('visibility-hidden');
      }
      miniCartHeading.querySelector('.mini-cart-count-display').innerHTML = '(' + itemCount + ')';
    }

    // Updating mini cart progress bar when items inside mini cart are modified
    const miniCartProgressBar = document.querySelector('.mini-cart-progress-bar');
    if ( miniCartProgressBar &&  itemCount == 0) {
      miniCartProgressBar.classList.add('hidden');
    } else {
      if (miniCartProgressBar.classList.contains('hidden')) {
        miniCartProgressBar.classList.remove('hidden');
      }
    }
  }

  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  enableLoading(line) {
    document.getElementById('main-cart-items').classList.add('cart__items--disabled');
    this.querySelectorAll(`#CartItem-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
    document.activeElement.blur();
    this.lineItemStatusElement.setAttribute('aria-hidden', false);
  }

  disableLoading() {
    document.getElementById('main-cart-items').classList.remove('cart__items--disabled');
  }
}

customElements.define('cart-items', CartItems);